import { makeStyles } from "components/providers/makeStyles";
import { JerseyAvatar } from "../heat/JerseyAvatar";
import { Avatar } from "@mui/material";
import { useRef, useState } from "react";
import { useResizeObserver } from "hooks/useResizeObserver";
import { styled } from "@mui/material/styles";

const useStyles = makeStyles((theme, { borderColor }) => ({
    avatars: {
        display: "flex",
        minHeight: 32,
        "& .MuiAvatar-root": {
            display: "inline-flex",
            width: 32,
            height: 32,
            fontSize: theme.typography.pxToRem(14),
            marginRight: -5,
            border: `1px solid ${borderColor ? borderColor.split(".").reduce((fullPath, path) => fullPath[path], theme.palette) : "white"}`,
        },
    },
}));

export const MoreAvatar = styled(Avatar, {
    shouldForwardProp: (prop) => prop !== "withShadow",
})(({ theme, withShadow }) => ({
    boxShadow: withShadow && theme.shadows.custom[0],
}));

export const AvatarGroup = ({
    competitors,
    borderColor,
    maxItems = 4,
    withShadow,
    containerRef,
}) => {
    const classes = useStyles({ borderColor });

    if (!competitors.length) return null;

    return (
        <section className={classes.avatars} ref={containerRef}>
            {competitors.slice(0, maxItems - 1).map((e) => (
                <JerseyAvatar
                    key={e.athleteId || e.id}
                    alt={e.athlete.name}
                    src={e.athlete.image}
                    className={classes.avatar}
                />
            ))}
            {maxItems > 0 && competitors.length > maxItems && (
                <MoreAvatar
                    withShadow={withShadow}
                >{`+${competitors.length - maxItems + 1}`}</MoreAvatar>
            )}
            {competitors.length === maxItems && (
                <JerseyAvatar
                    alt={competitors[maxItems - 1].athlete.name}
                    src={competitors[maxItems - 1].athlete.image}
                    className={classes.avatar}
                />
            )}
        </section>
    );
};

export const AvatarGroupFill = (props) => {
    const containerRef = useRef();
    const [maxItems, setMaxItems] = useState(0);

    const onResize = ([
        {
            contentRect: { width },
        },
    ]) => setMaxItems(Math.floor(width / 32));

    useResizeObserver(containerRef, onResize);

    return (
        <AvatarGroup
            {...props}
            maxItems={maxItems}
            containerRef={containerRef}
        />
    );
};
